// removed by extract-text-webpack-plugin
module.exports = {"imageWrap":"imageWrap__3_R2l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageArea/index.css
// module id = 1363
// module chunks = 0